export enum RespondentDeclineStages {
  confirm,
  declining,
  declined,
  declineError,
}
